import { DAY_MS } from './useSafePOKT.constants'
import { CoinGeckoClient } from 'coingecko-api-v3'

export const getRemainingDays = (targetDate: number) => {
  const remainingDays = Math.floor( (targetDate - Date.now()) / DAY_MS)

  if (remainingDays > 0) {
    return `${remainingDays} ${remainingDays === 1 ? 'Day' : 'Days'}`
  } else {
    return 'Today'
  }
}

const CoinGecko = new CoinGeckoClient({
    timeout: 10000,
    //   autoRetry: false,
    //   extraHTTPSOptions: {
    //       headers: {
    //           'Access-Control-Allow-Origin': 'http://localhost:3000'
    //       }
    //   }
}) 

export const getPoktPrice = async () => {
    try {

        const status = await CoinGecko.ping(); //check api status
        if (status.gecko_says) {
            const data = await CoinGecko.simplePrice({
                ids: 'pocket-network',
                vs_currencies: 'usd'
            });
            if (data['pocket-network']['usd']) {
                return data['pocket-network']['usd']
            }             
        }
        return 0

    } catch (error) {
        return 0
    }
}

export const POKT_PER_NODE_EST = 15000

export const msToDays = (ms: number) => ms / DAY_MS + ' days'

export const msToDate = (ms: number) => new Date(ms).toLocaleDateString('en-US').replace(/202/,'2')

export const poktToNodes = (pokt: number) => pokt / POKT_PER_NODE_EST

export const sharesToNodes = (shares: number, pps: number) => poktToNodes(shares * pps)

export const usdToNodes = (usd: number, poktPriceusd: number) => usd / (poktPriceusd * POKT_PER_NODE_EST)

export const SharesUntilNewNode = (totalPokt: number, poktPerShare: number) => {
    const remainingPokt = totalPokt % POKT_PER_NODE_EST
    return ( (POKT_PER_NODE_EST - remainingPokt) / poktPerShare)
}
